export const environment = {
  production: true,
  name: "prod",
  gtmId: 'G-KLZHM4F5RV',
  // useHash: true,
  serverUrl: "https://api.gigsumo.com/",
  websiteUrl: "https://www.gigsumo.com/",
  ssrUrl: "https://www.gigsumo.com/",
  careOnlineWebUrl: "https://app.gigsumo.com/#/",
  directoryUrl: "http://careonline-directory.s3-website-us-east-1.amazonaws.com/#/",
  webSocketUrl: "https://server-prod-lb.gigsumo.com:8090/gigsumo-social/ws",
  webSocketUrlStream: "https://stream-prod-lb.gigsumo.com:8090/gigsumo-social/ws",
  LAMDA_URL_temp_contactus: "https://api.gigsumo.com/contactus",
  LAMDA_URL: "https://njwxccoe70.execute-api.us-east-1.amazonaws.com/PROD/subscription/",
  // LAMDA_URL: "https://70yn13s9n6.execute-api.us-west-1.amazonaws.com/Dev/subscription/",
  AsyncSync: "SYNC",
  googleRedirectUri: "",
  buildDate: '20260316',
};
